import { Pipe, PipeTransform } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Pipe({
    name: 'buscador'
})

export class BuscadorPipe implements PipeTransform {

    /**
     * Se hace cargo de filtrar los resultados de una consulta de 
     * acuerdo al tipo de buscador y el textp que se coloque en el input
     * @param busqueda 
     * @param buscador 
     * @param filtro 
     */
    transform(busqueda:Array<any>, buscador:string, filtro:string):any{
        // Checa que la búsqueda regresará nulo
        if(!busqueda)
            return busqueda;
        else{
            // Checa si el filtro tiene algo escrito y si existen registros en la búsqueda
            if(filtro && filtro.trim().length > 0 && busqueda.length > 0){
                filtro = filtro.toLowerCase();
                let filtradoObjetos = [];
                // Realiza el filtrado de acuerdo al tipo de buscador que se seleccionó
                switch(buscador) {
                    case 'clientes':
                    case 'clientesArchivados':
                        // Filtrado por nombre de cliente. Las dos pestañas usan
                        // el mismo criterio: la separación entre vigentes y
                        // archivados ya la hizo el componente.
                        filtradoObjetos = busqueda.filter(function (cliente){
                            if(cliente.nombre == undefined)
                            {
                                return false
                            }
                            else {
                                return cliente.nombre.toLowerCase().indexOf(filtro) != -1
                            }

                        });
                        break;
                    case 'contactos':
                        // Filtrado por nombre de contacto
                        filtradoObjetos = busqueda.filter(contacto =>{
                            if(contacto.email != undefined){
                                if(contacto.email.toLowerCase().indexOf(filtro) != -1)
                                    return contacto.email.toLowerCase().indexOf(filtro) != -1
                            }
                            if(contacto.nombre != undefined)
                            {
                                if(contacto.nombre.toLowerCase().indexOf(filtro) != -1)
                                return  contacto.nombre.toLowerCase().indexOf(filtro) != -1
                            }
                            
                        });
                        break;
                    case 'confirmaciones':
                        // Filtrado por número de confirmación
                        filtradoObjetos = busqueda.filter(confirmacion => confirmacion.idTrosten.toLowerCase().indexOf(filtro) != -1);
                        break;
                    case 'cotizaciones':
                        // Filtrado por número de cotizacion, origen o destino
                        filtradoObjetos = busqueda.filter(cotizacion => (cotizacion.idTrosten.toLowerCase().indexOf(filtro) != -1 || (cotizacion.aliasOrigen && cotizacion.aliasOrigen.toLowerCase().indexOf(filtro) != -1) || (cotizacion.aliasDestino && cotizacion.aliasDestino.toLowerCase().indexOf(filtro) != -1)));
                        break;
                    case 'unidades':
                        // Filtrado por número de cotizacion, origen o destino
                        filtradoObjetos = busqueda.filter(unidad => (unidad.clave.toLowerCase().indexOf(filtro.toLowerCase()) != -1 || (unidad.marca.toLowerCase().indexOf(filtro.toLowerCase()) != -1) || (unidad.tipoDeUnidad.toLowerCase().indexOf(filtro.toLowerCase()) != -1)));
                        break;
                    default:
                        return;
                }
                return filtradoObjetos;
            } else { // Si el filtro viene vacío, no hace ningún filtro
                return busqueda;
            }
        }
    }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/buscador.pipe.ts